import { render, staticRenderFns } from "./AccountingVatListingModal.vue?vue&type=template&id=bf10363c"
import script from "./AccountingVatListingModal.vue?vue&type=script&lang=ts"
export * from "./AccountingVatListingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf10363c')) {
      api.createRecord('bf10363c', component.options)
    } else {
      api.reload('bf10363c', component.options)
    }
    module.hot.accept("./AccountingVatListingModal.vue?vue&type=template&id=bf10363c", function () {
      api.rerender('bf10363c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatListingModal.vue"
export default component.exports